import React from 'react';
import { motion } from 'framer-motion';
import { TrendingDown, BatteryCharging, ShieldCheck } from 'lucide-react';
export function Proof() {
  return <section className="py-20 px-4 bg-brand-orange/10 border-y border-brand-orange/20" data-id="element-178">
      <div className="max-w-4xl mx-auto text-center" data-id="element-179">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} data-id="element-180">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 text-white" data-id="element-181">
            Resultados Típicos en los Primeros 7 Días
          </h2>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-182">
            <div className="bg-navy-900/80 backdrop-blur-sm p-6 rounded-xl border border-brand-orange/30" data-id="element-183">
              <ShieldCheck className="w-10 h-10 text-brand-light mx-auto mb-4" data-id="element-184" />
              <p className="text-lg font-medium text-gray-200" data-id="element-185">
                Reducción visible en la inflamación facial
              </p>
            </div>

            <div className="bg-navy-900/80 backdrop-blur-sm p-6 rounded-xl border border-brand-orange/30" data-id="element-186">
              <BatteryCharging className="w-10 h-10 text-brand-light mx-auto mb-4" data-id="element-187" />
              <p className="text-lg font-medium text-gray-200" data-id="element-188">
                Niveles de energía estables durante toda la tarde
              </p>
            </div>

            <div className="bg-navy-900/80 backdrop-blur-sm p-6 rounded-xl border border-brand-orange/30" data-id="element-189">
              <TrendingDown className="w-10 h-10 text-brand-light mx-auto mb-4" data-id="element-190" />
              <p className="text-lg font-medium text-gray-200" data-id="element-191">
                Caída en los niveles de glucosa en ayunas (documentada)
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}